import React, { useEffect, useMemo, useRef, useState } from "react";
import { Alert, Container, Modal, OverlayTrigger, Toast, Tooltip } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import { shallowEqual, useSelector } from "react-redux";
import * as pharmaDeliveriesCrud from "../../_redux/pharma-deliveries/pharmaDeliveriesCrud";
import * as pharmaCrud from '../../_redux/pharma/pharmaCrud'
import { errorMsg } from "../../../Global/helpers";
import { informarMailRetiroFarmacia } from "../../mailRetiroFarmacia";

const useFocus = () => {
  const htmlElRef = useRef(null)
  const setFocus = () => { htmlElRef.current && htmlElRef.current.focus() }
  return [htmlElRef, setFocus]
}

export function OrderScanner({ ordersToReceive, setOrdersToReceive, ordersAvailable }) {
    const [inputRef, setInputFocus] = useFocus()
    const [gs1Manual, setGs1Manual] = useState("")
    const { authState } = useSelector( (state) => ({ authState: state.auth }), shallowEqual );
    const { user } = authState;
    const [loading, setLoading] = useState(false);

    const handleManualKeyDown = (e)=>{
        if (e.key != 'Enter') return;
        if (!gs1Manual) return;
        if (ordersToReceive.some(p => p.id == gs1Manual)) {
            setGs1Manual("");
            return;
        }
        handleGetPedido(gs1Manual);
        setGs1Manual("");
    }

    const handleSubmit = (e)=>{
        if(e.key!='Enter'){
            return
        }
        e.preventDefault()
        let cadena = e?.target?.value;
        if (!cadena) return;
        // Evitar duplicados: no buscar ni agregar si ya fue escaneado
        if (ordersToReceive.some(p => p.id == cadena)) {
            if (inputRef?.current) inputRef.current.value = "";
            return;
        }
        handleGetPedido(cadena);
        if (inputRef?.current) {
            inputRef.current.value = "";
        }
    }


    const handleGetPedido = async (orderId) => {
        // Validar que el pedido esté disponible para recepción
        if (!ordersAvailable?.some(id => id == orderId)) {
            errorMsg("El pedido " +  orderId + " no se encuentra disponible para recepción" )
            return;
        }
        // Evitar duplicados
        if (ordersToReceive.some(p => p.id == orderId)) return;

        try {
            setLoading(true);
            
            const respRecepcion = await pharmaCrud.setOrderReceived({id:orderId})

            const resp = await pharmaDeliveriesCrud.getOrderById(orderId);
            const pedido = resp.data.results;
            setOrdersToReceive(prev => [...prev, pedido]);

            // Aviso al cliente de que ya puede retirar el pedido (solo unidad de negocio Mi Test)
            await informarMailRetiroFarmacia(orderId, respRecepcion?.data?.mail_retiro_farmacia)
        } catch (err) {
            errorMsg("No se encontró el pedido: " + orderId)
        } finally {
            setLoading(false);
        }
    };

    const handleUndoPicking = (line) => {
        setOrdersToReceive(prev =>
            prev.map(pedido => ({
                ...pedido,
                lines: pedido.lines.filter(l => l.id !== line.id)
            })).filter(pedido => pedido.lines.length > 0)
        );
    };

    useEffect(()=>{
        setInputFocus();
    },[])

    return (
        <div>

                <p className="text-center" onClick={()=>setInputFocus()}>
                    <img src={toAbsoluteUrl("/media/barcode.gif")} alt="image" style={{width: "200px"}}/>
                </p>

                <input type="text" style={{opacity:"0"}} ref={inputRef} onKeyDown={(e) => handleSubmit(e) }></input>

                {user?.role?.id == 1 && (
                    <input type="text" autoComplete="off" className="form-control" 
                        value={gs1Manual || ""} 
                        onChange={e => setGs1Manual(e?.target?.value)}
                        onKeyDown={handleManualKeyDown}>
                    </input>
                )}


                <table className="table">
                    <thead>
                        <tr>
                            <th style={{textAlign:'center'}}>Órden</th>
                            <th style={{textAlign:'center'}}>SKU</th>
                            <th style={{textAlign:'center'}}>Producto</th>
                            <th style={{textAlign:'center'}}>Cantidad</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {ordersToReceive?.map(pedido =>
                            pedido?.lines?.map((line, idx) => (
                                <tr key={`${pedido.id}-${idx}`}>
                                    {idx === 0 && (
                                        <td rowSpan={pedido.lines.length} style={{textAlign:'center', verticalAlign:'middle', fontWeight:"bold"}}>
                                            {pedido.id} <i className="fas fa-check-circle text-success ml-1"></i>
                                        </td>
                                    )}
                                    <td style={{textAlign:'center', verticalAlign: 'middle'}}>{line.sku}</td>
                                    <td style={{textAlign:'left', verticalAlign: 'middle'}}>{line.product}</td>
                                    <td style={{textAlign:'center', verticalAlign: 'middle'}}>{line.qty}</td>
                                    <td style={{textAlign:'center', verticalAlign: 'middle'}}>
                                        <OverlayTrigger overlay={<Tooltip id="waves-print-tooltip">Deshacer picking</Tooltip>} >
                                            <button type="button" className="btn btn-icon btn-light btn-hover-primary btn-sm mx-1" 
                                                onClick={() => handleUndoPicking(line)} > 
                                                <span><i className="fas fa-undo text-info"></i></span> 
                                            </button>
                                        </OverlayTrigger>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>


        </div>
    );
}
    